<template>
  <component
    :is="tag"
    :disabled="disabled"
    :class="[
      'flex-grow transition-colors duration-150 ease-in-out px-4 py-0.5 rounded focus:outline-none',
      {
        'bg-white dark:bg-gray-600 text-gray-900 dark:text-gray-50 shadow-sm font-medium': isActive,
        'cursor-pointer hover:text-gray-700 dark:hover:text-gray-200 focus:ring-2 focus:ring-white dark:focus:ring-gray-700': !isActive && !disabled,
        'cursor-not-allowed text-gray-400': disabled && !isActive,
      },
    ]"
    :aria-disabled="disabled ? 'true' : null"
    :aria-selected="isActive ? 'true' : 'false'"
    :tabindex="isActive || disabled ? null : 0"
    @click.stop.prevent="changed"
    @keyup.enter.stop.prevent="changed"
    @keyup.space.stop.prevent="changed"
  >
    {{ label }}
  </component>
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { inject, computed } from 'vue'

const props = defineProps({
  disabled: useProp(Boolean),
  name: useProp(String),
  label: useProp(String),
  tag: useProp(String, 'Button')
})

const selectedSegment = inject('selectedSegment', null)
const setSegment = inject('setSegment')

const changed = () => {
  if (!props.disabled) {
    setSegment(props.name)
  }
}

const isActive = computed(() => props.name === selectedSegment.value)

</script>
